module.exports = __webpack_public_path__ + "static/media/sequelize.7901245b.png";